export const companyNameResort = function (companyname) {
    // The Companyname which is coming from LOCS is not well formated so we need to resort the values.
    // Firstname first, Last name second, delete commas
    companyname = companyname.replace(" u. ", " und ");

    // count commas
    let countcommascompanyname = (companyname.match(/,/g) || []).length;
    let companynamewords = companyname.split(", ");

    // only 1 commadf
    if (countcommascompanyname == 1) {
        // console.log("1 komma");
        let newname;
        let phrasewithund;
        let countblanks;
        let newname1 = companynamewords[1].trim();

        switch (true) {
            case newname1.includes("GmbH"):
                newname = companynamewords[0] + " " + newname1;
                return newname;

            case newname1.includes(" und "):
                // console.log("case und mit split "+newname1);
                phrasewithund = newname1.split(" und "); 
                // Search for blanks           
                countblanks = (phrasewithund[1].match(/ /g) || []).length;
                if(countblanks>0){
                    // console.log(countblanks+" ist groesser 0");
                      newname = phrasewithund[0] + " " +  companynamewords[0] +   " und " + phrasewithund[1];
                      return newname;
                } else {
                    newname = phrasewithund[0] + " und " + phrasewithund[1]  + " " + companynamewords[0];
                    return newname;      
                }          

            default:
                // console.log("case default");                
                newname = newname1 + " " + companynamewords[0];
                return newname;
        }

    }


    // 2 commas
    if (countcommascompanyname == 2) {
        // console.log("2 kommas");

        let newname;
        let newname2 = companynamewords[2].trim();

        // console.log("wo: "+newname1);
        switch (true) {
            case newname2 == "GmbH.*" || newname2 == "GbR" && !newname2.startsWith("und "):
                // console.log("case 1");
                return companynamewords[1] + " " + companynamewords[0] + " " + newname2;

            case newname2.includes("GmbH.*") || newname2.includes("GbR") && !newname2.startsWith("und "):
                // console.log("case 2");
                return companynamewords[2] + " " + companynamewords[1] + " " + companynamewords[0];

            case newname2.startsWith("und "):
                // console.log("case 3 " + newname2);
                newname = companynamewords[1] + " " + companynamewords[0] + " " + newname2;
                return newname;

            case newname2.includes("Prof."):
                // console.log("case 4");
                newname = newname2 + " " + companynamewords[1] + " " + companynamewords[0];
                return newname;       
                
            case newname2.includes("von"):
                    // console.log("case 7 von");
                    newname = companynamewords[1] + " " +newname2 + " "  + companynamewords[0];
                    return newname;                    

            case newname2.includes("Dr.") && newname2.startsWith("und "):
                // console.log("case 5");
                newname2 = newname2.replace("und ", " ");
                newname = newname2 + " und " + companynamewords[1] + " " + companynamewords[0];
                return newname;

            case newname2.includes("Dr."):
                // console.log("case 6");                
                newname = newname2 + " " + companynamewords[1] + " " + companynamewords[0];
                return newname;

            case newname2.startsWith("& "):
                newname = companynamewords[1] + " " + companynamewords[0] + "  " + newname2;
                return newname;

            default:
                newname = companynamewords[1] + " " + companynamewords[0] + " " + newname2;
                // console.log("case default");
                return newname;
        }

    }

    // 3 commas
    if (countcommascompanyname == 3) {
        // console.log("3 komma");
        let newname;
        let newname2 = companynamewords[2].trim();
        let newname3 = companynamewords[3].trim();

        // console.log("newname2: " + newname2);
        // console.log("newname3: " + newname3);        

        switch (true) {
            case newname3.includes("GmbH") && (!newname2.includes("Dr.") && !newname2.includes("Prof.")):
                // console.log("case 1");
                newname = companynamewords[1] + " " + companynamewords[0] + " " + newname3 + " " + companynamewords[2];
                return newname;

            case newname3.includes("GmbH") && (newname2.includes("Dr.") || newname2.includes("Prof.")):
                newname = newname2 + " " + companynamewords[1] + " " + companynamewords[0] + " " + newname3;
                return newname;

            case newname3.includes("GbR") && (newname2.includes("Dr.") || newname2.includes("Prof.")):
                // console.log("case 3");                
                newname = newname2 + " " + companynamewords[1] + " " + companynamewords[0] + " " + newname3;
                return newname;                

            case newname3.includes("GbR"):
                // console.log("case 4");
                newname = companynamewords[1] + " " + companynamewords[0] + ", " + companynamewords[2] + " " + newname3;
                return newname;

            case newname2.includes("Dr."):
                // console.log("case 5");
                newname = newname2 + " " + companynamewords[1] + " " + companynamewords[0] + " " + newname3;
                return newname;

            case newname3.startsWith("und ") && !newname2.includes("Prof."):
                // console.log("case 6");
                newname = companynamewords[1] + " " + companynamewords[0] + " " + companynamewords[2] + " " + newname3;
                return newname;

            case newname3.startsWith("und ") && newname2.includes("Prof."):
                    // console.log("case 7");
                    newname = newname2 + " " +companynamewords[1] + " " + companynamewords[0] + " " + newname3;
                    return newname;                

            default:
                // console.log("case default");
                newname = companynamewords[1] + " " + companynamewords[0] + ", " + companynamewords[2] + " " + newname3;
                return newname;
        }
    }

    // 4 commas
    if (countcommascompanyname == 4) {
        let newname;
        let newname2 = companynamewords[2].trim();
        let newname3 = companynamewords[3].trim();

        switch (true) {

            case newname2.includes("Dr"):
                newname = companynamewords[2] + " " + companynamewords[1] + " " + companynamewords[0] + " " + newname3 + " " + companynamewords[4];
                return newname;

            case newname3.includes("GmbH") || newname3.includes("GbR") || newname3.includes("AG"):
                newname = companynamewords[1] + " " + companynamewords[0] + " " + newname3 + " " + companynamewords[2] + companynamewords[4];
                return newname;

            default:
                newname = companynamewords[1] + " " + companynamewords[0] + " " + newname3 + " " + companynamewords[2] + companynamewords[4];
                return newname;
        }

    }

    // mehr als 4 commas
    // If there are more than 4 commas, we just switch first and second name and leave the rest like it is
    if (countcommascompanyname > 4) {
        let newname;
        let wholephrase = companyname.split(", ");

        let delete1 = wholephrase[0];
        let delete2 = wholephrase[1];
        // I had no solution to replace more than one string - so I replace it like this 
        let replace1 = (companyname.replace(delete1 + ",", ""));
        let companynameWithoutFirstAndSecond = (replace1.replace(delete2 + ",", ""));
        newname = companynamewords[1] + " " + companynamewords[0] + " " + companynameWithoutFirstAndSecond;

        return newname;
    }

    return companyname;
}
